module.exports = __webpack_public_path__ + "static/media/fetal-pillow-brochure@2x.ed031ad2.png";